import { CurrencyEnum } from 'types/swagger';

type HasCentsObject = Record<CurrencyEnum, boolean>;

export const hasCentsObject: HasCentsObject = {
  [CurrencyEnum.CLP]: false,
  [CurrencyEnum.COP]: true,
  [CurrencyEnum.USD]: true,
  [CurrencyEnum.MXN]: true,
  [CurrencyEnum.BRL]: true,
  [CurrencyEnum.PEN]: true,
  [CurrencyEnum.EUR]: true,
  [CurrencyEnum.UYU]: true,
};

export const hasCents = (currency: CurrencyEnum): boolean => hasCentsObject[currency];

// Number of decimals to display according to currencies
// Default value in formatter is net
export const DECIMALS_FOR_CURRENCY = {
  gross: {
    currencyWithCents: 4,
    currencyWithoutCents: 2,
  },
  net: {
    currencyWithCents: 2,
    currencyWithoutCents: 0,
  },
};
